import { provideComponent } from "scrivito"

import { LogoSliderWidget } from "./LogoSliderWidgetClass"
import "./styles/_logo-slider-widget.scss"
import { LogoSliderWidgetView } from "./ui/LogoSliderWidgetView"

provideComponent(LogoSliderWidget, LogoSliderWidgetView)
